var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "detail" } },
    [
      _c("div", { staticClass: "header" }, [
        _c("div", { staticClass: "title" }, [
          _vm._v(_vm._s(_vm.$t("ticimax.ticimaxDetail"))),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "subtitle" }, [
          _vm._v(_vm._s(_vm.$t("ticimax.manageIntegrationDesc"))),
        ]),
      ]),
      _vm._v(" "),
      _c("UpdateTicimaxChannel", { attrs: { channel: _vm.clone } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }